<template>
  <span class="block">
    <el-select
      v-model="dataValue"
      filterable
      clearable
      @change="selecDate"
      class="selectWord"
      placeholder="请选择月份"
      @clear="remove"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>
    </el-select>
    <!-- <el-date-picker
      class="date-picker"
      v-model="value"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      @change="dataSearch"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      v-if="hackReset"
      align="right"
    ></el-date-picker> -->
  </span>
</template>

<script>
export default {
	props: {
    addMonth: {
       type: Number,
       default: 1,
       required: false
    }
	},
  data() {
    return {
      radio: 0,
      options: [
      ],
      value: [],
      dataValue: "",
      hackReset: true,
      month: '',
      year: ''
    };
  },
  created() {
    this.setOPtions()
  },
  methods: {
      remove(){
         this.$emit('clear', {});
      },
    //设置日期选项
    setOPtions() {
      var date = new Date(); //获取当前日期对象
      this.year = date.getFullYear(); //获取当前年份
      var month = date.getMonth() + this.addMonth; //获取当前月份
      let value, label
      for(var i = 1; i <= month; i++) {
        this.month = i < 10 ? `0${i}` : `${i}`
        value = `${this.year}年${this.month}月`
        label= `${this.year}年${this.month}月`
        this.options.unshift({ value, label})
      }
      for(var k = 1; k <= (12 - month); k++){
        let a = 13 - k
        this.month = a < 10 ? `0${a}` : `${a}`
        value = `${this.year -1}年${this.month}月`
        label= `${this.year - 1}年${this.month}月`
        this.options.push({ value, label})

      }
      
      this.dataValue = this.options[0].value;
	this.selecDate(this.options[0])
    },
    //快速定位日期
    selecDate(item) {
		if(!item){
		return	this.$emit('MonthSearch', ['',''])
		}
      this.dataValue = item.value;
      let year = this.dataValue.split('年')[0]
      var start, end, searchMonth, monthDay;
      if(item.value) {
        searchMonth = item.value.slice(5,7)
      }
      if(searchMonth == '01' || searchMonth == '03' || searchMonth == '05' || searchMonth == '07' || searchMonth == '08' || searchMonth == '10' || searchMonth == '12') {
        monthDay = '31'
      }else if( searchMonth == '04' || searchMonth == '06' || searchMonth == '09' || searchMonth == '11') {
        monthDay = '30'
      }else if(searchMonth == '02') {
        let isRunYear = this.mxIsRunYear(this.year)
        if(isRunYear) {
          monthDay = '29'
        }else {
          monthDay = '28'
        }
      }
      start = year + '-' + searchMonth + '-' + '01' + ' '+  '00:00:00'
      end = year + '-' + searchMonth + '-' + monthDay + ' ' + '23:59:59'
      if(start && end) {
        this.$set(this.value, "0", start)
        this.$set(this.value, "1", end)
        this.$emit('MonthSearch', this.value)
      }
      this.$nextTick(() => {
        this.hackReset = true
        this.$emit('pick', [start, end]);
      });
    },
  },
};
</script>
<style scoped lang="stylus">
.selectWord
  width: 155px
.date-picker {
  margin-left: 10px;
  width: 250px;
}
.block {
  margin-right: 20px;
}
</style>